/* Impression SCDM — la ligne de coupe, en magenta, sur l apercu.

   Le client voit son dessin mais pas OU l autocollant sera coupe. On trace donc
   le contour de coupe par-dessus l apercu, en magenta — la couleur que le
   metier associe au CutContour.

   Comment on trouve ce contour, sans toucher a scdm.js : le configurateur
   dessine deja l autocollant sur sa toile, contour blanc compris, sur un fond
   transparent. La silhouette de l autocollant est donc exactement la zone
   opaque de la toile. On la lit, on en prend le bord, et on le peint sur une
   toile posee par-dessus. Ca marche pour les quatre formes de decoupe — carre,
   coins arrondis, rond, a la forme — sans avoir a les redessiner une a une.

   Deux precautions, apprises a l ecran :

   1. LA PLUS GRANDE FORME SEULEMENT. Les cotes (« 6 po ») et leurs fleches sont
      dessinees sur la meme toile. Un simple contour de tout ce qui est opaque
      les soulignait en magenta elles aussi. On ne garde donc que la plus grande
      forme d un seul tenant : l autocollant.

   2. ON BOUCHE LES TROUS. Un dessin peut avoir des parties transparentes en
      plein milieu ; sans ca, on aurait trace des lignes de coupe a l interieur
      de l autocollant, la ou rien ne sera coupe.

   Rien n est ajoute a la commande : c est un affichage, par-dessus, qui ne
   touche ni au fichier ni au prix.
*/

(function () {
  'use strict';

  function texteContour(cle, repli, params) {
    var pont = document.getElementById('scdmContourI18n');
    var texte = (pont && pont.getAttribute('data-' + cle)) || repli;
    Object.keys(params || {}).forEach(function (nom) {
      texte = texte.split('{' + nom + '}').join(String(params[nom]));
    });
    return texte;
  }


  var MAGENTA = '#FF00FF';    // la couleur que le metier associe au CutContour
  var TIRETS = [13, 9];       // longueur du tiret, longueur du blanc, en pixels de toile
  var EPAISSEUR = 3;
  var SEUIL_ALPHA = 128;      // au-dela, le pixel fait partie de l autocollant
  var PERIODE_MS = 250;       // on regarde si l apercu a change
  var MINI_FORME = 400;       // en dessous, ce n est pas un autocollant

  var toile = null;           // la toile du configurateur
  var calque = null;          // la notre, posee par-dessus
  var note = null;
  var signature = '';

  /* ------------------------------------------------------------ mise en place */

  function preparer() {
    toile = document.getElementById('scdmCanvas');
    if (!toile || !toile.parentElement) return false;

    if (!calque) {
      calque = document.createElement('canvas');
      calque.id = 'scdmCoupe';
      calque.setAttribute('aria-hidden', 'true');
      calque.style.cssText =
        'position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:3';
      toile.parentElement.appendChild(calque);
    }

    if (!note) {
      var cotes = document.getElementById('scdmCotes');
      if (cotes && cotes.parentElement) {
        note = document.createElement('p');
        note.className = 'scdm-coupe-note';
        note.hidden = true;
        note.textContent = texteContour('magenta', 'Le trait magenta montre la ligne de coupe : c’est là que l’autocollant sera découpé.');
        note.style.cssText = 'margin:6px 0 0;font-size:11.5px;line-height:1.45;color:var(--slate,#98A1B2)';
        cotes.parentElement.insertBefore(note, cotes.nextSibling);
      }
    }
    return true;
  }

  /* --------------------------------------------------------------- detection */

  /* Une empreinte bon marche de l apercu : on echantillonne l opacite tous les
     997 pixels. Si elle n a pas bouge, rien a refaire — inutile de repasser sur
     300 000 pixels quatre fois par seconde. */
  function empreinte(donnees, W, H) {
    var s = 0, n = 0;
    for (var i = 3; i < donnees.length; i += 997 * 4) {
      s += donnees[i] > SEUIL_ALPHA ? 1 : 0;
      n++;
    }
    return W + 'x' + H + ':' + s + '/' + n;
  }

  /* Suivi de bord de Moore : on tourne autour de la forme, voisin par voisin,
     et on note chaque pixel du contour dans l ordre du parcours. Le garde-fou
     evite la boucle infinie si la forme est degeneree. */
  function suivreBord(forme, W, H, sx, sy) {
    var VOISINS = [[1, 0], [1, 1], [0, 1], [-1, 1], [-1, 0], [-1, -1], [0, -1], [1, -1]];
    function plein(x, y) { return x >= 0 && y >= 0 && x < W && y < H && forme[y * W + x] === 1; }

    var points = [], cx = sx, cy = sy, dir = 6, garde = 0, maxi = 4 * (W + H) * 4;
    do {
      points.push([cx, cy]);
      var avance = false;
      for (var q = 0; q < 8; q++) {
        var nd = (dir + 1 + q) % 8;
        var nx = cx + VOISINS[nd][0], ny = cy + VOISINS[nd][1];
        if (plein(nx, ny)) { cx = nx; cy = ny; dir = (nd + 5) % 8; avance = true; break; }
      }
      if (!avance) break;
      garde++;
    } while (!(cx === sx && cy === sy) && garde < maxi);
    return points;
  }

  /* ------------------------------------------------------------------ tracer */

  function peindre() {
    if (!toile || !toile.width || !toile.height) return;

    var W = toile.width, H = toile.height, N = W * H;
    var donnees;
    try {
      donnees = toile.getContext('2d').getImageData(0, 0, W, H).data;
    } catch (e) {
      return;                      // toile salie par une image d une autre origine
    }

    var sig = empreinte(donnees, W, H);
    if (sig === signature) return;
    signature = sig;

    if (calque.width !== W || calque.height !== H) { calque.width = W; calque.height = H; }
    var ctx = calque.getContext('2d');
    ctx.clearRect(0, 0, W, H);

    var opaque = new Uint8Array(N);
    var total = 0;
    for (var i = 0, p = 3; i < N; i++, p += 4) {
      if (donnees[p] > SEUIL_ALPHA) { opaque[i] = 1; total++; }
    }
    if (total < MINI_FORME) { if (note) note.hidden = true; return; }

    /* 1. la plus grande forme d un seul tenant */
    var etiquette = new Int32Array(N);
    var pile = new Int32Array(N);
    var num = 0, gagnante = 0, gagnanteTaille = 0;
    for (var depart = 0; depart < N; depart++) {
      if (!opaque[depart] || etiquette[depart]) continue;
      num++;
      var taille = 0, sp = 0;
      pile[sp++] = depart; etiquette[depart] = num;
      while (sp) {
        var k = pile[--sp]; taille++;
        var x = k % W, y = (k / W) | 0;
        if (x > 0 && opaque[k - 1] && !etiquette[k - 1]) { etiquette[k - 1] = num; pile[sp++] = k - 1; }
        if (x < W - 1 && opaque[k + 1] && !etiquette[k + 1]) { etiquette[k + 1] = num; pile[sp++] = k + 1; }
        if (y > 0 && opaque[k - W] && !etiquette[k - W]) { etiquette[k - W] = num; pile[sp++] = k - W; }
        if (y < H - 1 && opaque[k + W] && !etiquette[k + W]) { etiquette[k + W] = num; pile[sp++] = k + W; }
      }
      if (taille > gagnanteTaille) { gagnanteTaille = taille; gagnante = num; }
    }
    if (gagnanteTaille < MINI_FORME) { if (note) note.hidden = true; return; }

    var forme = new Uint8Array(N);
    for (var j = 0; j < N; j++) forme[j] = etiquette[j] === gagnante ? 1 : 0;

    /* 2. boucher les trous : tout ce que le fond n atteint pas depuis les bords
          appartient a l autocollant. */
    var fond = new Uint8Array(N), sp2 = 0;
    for (var x2 = 0; x2 < W; x2++) {
      var haut = x2, bas = (H - 1) * W + x2;
      if (!forme[haut]) { fond[haut] = 1; pile[sp2++] = haut; }
      if (!forme[bas]) { fond[bas] = 1; pile[sp2++] = bas; }
    }
    for (var y2 = 0; y2 < H; y2++) {
      var g = y2 * W, dte = y2 * W + W - 1;
      if (!forme[g]) { fond[g] = 1; pile[sp2++] = g; }
      if (!forme[dte]) { fond[dte] = 1; pile[sp2++] = dte; }
    }
    while (sp2) {
      var k2 = pile[--sp2];
      var x3 = k2 % W, y3 = (k2 / W) | 0;
      if (x3 > 0 && !forme[k2 - 1] && !fond[k2 - 1]) { fond[k2 - 1] = 1; pile[sp2++] = k2 - 1; }
      if (x3 < W - 1 && !forme[k2 + 1] && !fond[k2 + 1]) { fond[k2 + 1] = 1; pile[sp2++] = k2 + 1; }
      if (y3 > 0 && !forme[k2 - W] && !fond[k2 - W]) { fond[k2 - W] = 1; pile[sp2++] = k2 - W; }
      if (y3 < H - 1 && !forme[k2 + W] && !fond[k2 + W]) { fond[k2 + W] = 1; pile[sp2++] = k2 + W; }
    }
    for (var j2 = 0; j2 < N; j2++) if (!fond[j2]) forme[j2] = 1;

    /* 3. suivre le bord dans l ordre, puis le tracer en pointille.

       On ne peut pas se contenter de peindre les pixels du bord : pour obtenir
       des tirets reguliers il faut parcourir le contour DANS L ORDRE. D ou ce
       suivi de bord a la Moore, qui tourne autour de la forme en gardant a sa
       gauche ce qui est plein. On obtient une suite de points, qu on trace
       ensuite comme un chemin, avec des tirets. */
    var amorce = -1;
    for (var t = 0; t < N && amorce < 0; t++) if (forme[t]) amorce = t;
    if (amorce < 0) { if (note) note.hidden = true; return; }

    var points = suivreBord(forme, W, H, amorce % W, (amorce / W) | 0);
    if (points.length < 8) { if (note) note.hidden = true; return; }

    /* Un point tous les trois pixels suffit : ca lisse l escalier des pixels
       sans deformer la ligne. */
    var pas = Math.max(1, Math.round(points.length / 500));

    ctx.beginPath();
    for (var v = 0; v < points.length; v += pas) {
      var pt = points[v];
      if (v === 0) ctx.moveTo(pt[0] + 0.5, pt[1] + 0.5);
      else ctx.lineTo(pt[0] + 0.5, pt[1] + 0.5);
    }
    ctx.closePath();
    ctx.setLineDash(TIRETS);
    ctx.lineWidth = EPAISSEUR;
    ctx.lineJoin = 'round';
    ctx.strokeStyle = MAGENTA;
    ctx.stroke();

    if (note) note.hidden = false;
  }

  /* ---------------------------------------------------------------- demarrage */

  function demarrer() {
    if (!preparer()) return;
    peindre();
    setInterval(peindre, PERIODE_MS);
    window.addEventListener('resize', function () { signature = ''; });
  }

  function quandPret(n) {
    if (document.getElementById('scdmCanvas')) return demarrer();
    if ((n || 0) > 60) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
